export default "__VITE_ASSET__Con_BnD5__"